<div class="container-fluid tp-box vd-host" [@flipState]="flip">
	<div class="row tp-box__side tp-box__back" *ngIf="flip == 'active'">
		<div class="cw-wrap vd-wrap" [ngStyle]="themeVars">
			<div class="cw-icon-badge pointer" (click)="toggleFlip(false, '')" title="Back">
				<i class="material-icons">login</i>
			</div>
			<div class="cw-header">
				<div class="cw-title-group">
					<span class="cw-title">{{ title }}</span>
				</div>
				<div class="vd-toolbar">
					<button class="btn btn-success btn-sm" (click)="exportXls()" [disabled]="exporting || !viewing || viewing.length === 0">
						<i class="fa fa-file-excel-o"></i>
					</button>
					<button class="btn btn-danger btn-sm" (click)="exportPdf()" [disabled]="exporting || !viewing || viewing.length === 0">
						<i class="fa fa-file-pdf-o"></i>
					</button>
				</div>
			</div>
			<div class="cw-body" *ngIf="viewing">
				<div class="table" #print_table>
					<table class="table table-sm table-fixed">
						<thead>
						<tr>
							<th>Vendor#</th>
							<th>GRN#</th>
							<th>Order#</th>
							<th>PO Item</th>
							<th>Date</th>
							<th>Item</th>
							<th>Desc</th>
							<th class="text-right">Price</th>
							<th class="text-center">Ordered</th>
							<th class="text-center">Received</th>
							<th class="text-center">Invoiced</th>
							<th class="text-right">Line Total</th>
						</tr>
						</thead>
						<tbody>
						<tr *ngFor="let d of viewing">
							<td>{{ d.supplierid }}</td>
							<td>{{ d.grnno}}</td>
							<td>{{ d.orderno}}</td>
							<td>{{ d.podetailitem}}</td>
							<td>{{ d.deliverydate }}</td>
							<td>{{ d.itemcode }}</td>
							<td>{{ d.itemdescription }}</td>
							<td class="text-right">{{ d.unitprice | currency}}</td>
							<td class="text-center">{{ d.quantityord}}</td>
							<td class="text-center">{{ d.qtyrecd}}</td>
							<td class="text-center">{{ d.quantityinv}}</td>
							<td class="text-right">{{ d.unitprice * d.quantityord | currency}}</td>
						</tr>
						</tbody>
					</table>
				</div>
			</div>
		</div>
	</div>
	<div class="row tp-box__side tp-box__front" id="frontside" [ngClass]="flip == 'inactive' ? '' : 'd-none'">
		<div class="col-12 p-0">
			<app-dashboard-stat-card
				[title]="title"
				icon="login"
				accent="primary"
				[value]="data ? data.length : null"
				[loading]="!data"
				[showView]="!!data"
				(view)="toggleFlip(data, title)">
			</app-dashboard-stat-card>
		</div>
	</div>
</div>
